import { TextField, TextFieldProps } from '@mui/material';
import { useCallback, useDeferredValue, useEffect, useState } from 'react';

type Props = {
  onChangeHandler: (value: string) => void;
} & Partial<TextFieldProps>;

export const DebouncedTextField: React.FC<Props> = ({
  onChangeHandler,
  defaultValue = '',
  ...rest
}) => {
  const [value, setValue] = useState<string>(defaultValue as string);
  const deferredValue = useDeferredValue(value);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  }, []);

  useEffect(() => {
    onChangeHandler(deferredValue);
  }, [deferredValue, onChangeHandler]);

  return <TextField {...rest} value={value} onChange={handleChange} />;
};
